import React from 'react';
import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';

const { Panel } = Collapse;

const Accordion = ({ panels }) => (
  <Collapse expandIconPosition="end">
    {_.map(panels || [], (panel, index) => (
      <Panel header={panel.title} key={index}>
        {panel.content}
      </Panel>
    ))}
  </Collapse>
);

Accordion.propTypes = {
  panels: PropTypes.array,
};

export default Accordion;
